
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Image from "next/image";
import Layout from "containers/Layout/Layout";
import { resolvedPublicPath } from "utils/utils";
const Custom404 = () => {
    return (<Layout title="404" hideHeaderFooter>
			<div className="min-h-screen flex flex-col items-center justify-center">
				<Image src={resolvedPublicPath("404.svg")} width={649} height={433} alt="404" priority/>
				<div className="mt-36">
					<Image src={resolvedPublicPath("yocale-logo.svg")} alt={"Powered by Yocale"} width={100} height={48} loading="lazy"/>
				</div>
			</div>
		</Layout>);
};
export default Custom404;

    async function __Next_Translate__getStaticProps__18e811106d9__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/404',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18e811106d9__ as getStaticProps }
  